export const LEFT_NAV_WIDTH = "3rem"
export const LEFT_NAV_HEIGHT = "3rem"
export const inputSizePaddingMap = new Map([
  [undefined, "11px 14px 11px 14px!important"],
  ["normal", "11px 14px 11px 14px!important"],
  ["medium", "11px 14px 11px 14px!important"],
  ["small", "5px 8px 5px 8px!important"]
])
